import { Grid, Stack, Typography } from "@mui/material";
import CompanySelectionDialogIcon from "@entrilia/shared/icons/CompanySelectionDialogIcon";

const NoWidgetSelected = () => {
  return (
    <Grid container sx={{ flex: 1, alignItems: "center", justifyContent: "center", width: "100%" }}>
      <Stack spacing={3} sx={{ alignItems: "center", textAlign: "center" }}>
        <CompanySelectionDialogIcon sx={{ height: 80, width: 80 }} />
        <Typography color="secondary">Select a widget to view copying information</Typography>
      </Stack>
    </Grid>
  );
};

export default NoWidgetSelected;
